import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.40994 3C7.05827 3 7.58385 3.52558 7.58385 4.17391V9.76398C7.58385 10.9352 8.04912 12.0585 8.87731 12.8867C9.7055 13.7149 10.8288 14.1801 12 14.1801C13.1712 14.1801 14.2945 13.7149 15.1227 12.8867C15.9509 12.0585 16.4161 10.9352 16.4161 9.76398V4.17391C16.4161 3.52558 16.9417 3 17.5901 3C18.2384 3 18.764 3.52558 18.764 4.17391V9.76398C18.764 11.5579 18.0513 13.2783 16.7829 14.5468C15.5144 15.8153 13.7939 16.528 12 16.528C10.2061 16.528 8.48564 15.8153 7.21715 14.5468C5.94866 13.2783 5.23602 11.5579 5.23602 9.76398V4.17391C5.23602 3.52558 5.7616 3 6.40994 3ZM3 19.8261C3 19.1778 3.52558 18.6522 4.17391 18.6522H19.8261C20.4744 18.6522 21 19.1778 21 19.8261C21 20.4744 20.4744 21 19.8261 21H4.17391C3.52558 21 3 20.4744 3 19.8261Z'
            />
        </SvgIcon>
    );
});
